import { useTranslation } from 'react-i18next';
import { ClipboardList, Square } from 'lucide-react';

const CHECKLIST = [
  'verifyRentRoll', 'requestTaxReturns', 'inspectStructure', 'confirmExpenses',
  'reviewLeases', 'obtainFinancing', 'negotiateOffer', 'reRunAnalysis',
];

export default function ActionPlan() {
  const { t } = useTranslation();

  return (
    <div data-testid="action-plan" className="bg-white dark:bg-[#0F1419] border border-slate-200 dark:border-white/[0.06] rounded-xl p-5">
      <div className="flex items-center gap-2 mb-4">
        <ClipboardList className="w-4 h-4 text-violet-500" />
        <h3 className="font-semibold text-sm text-slate-900 dark:text-white">{t('decision.actionPlan')}</h3>
      </div>
      <div className="space-y-1.5">
        {CHECKLIST.map(item => (
          <div key={item} className="flex items-start gap-2.5 py-1">
            <Square className="w-4 h-4 text-slate-300 dark:text-slate-600 flex-shrink-0 mt-0.5" />
            <span className="text-sm text-slate-600 dark:text-slate-300">{t(`decision.checklist_${item}`)}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
